import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

/**
 * 招标采购 - 委托采购
 */
export default {
  path: 'entrust',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '委托采购',
    icon: 'icon-side_purchase_entrust',
    layout: 'DefaultLayout',
    grayscale: 'purchase-entrust'
  },
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
  ],
  platformAlias: [],
  applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
  roles: [
    platformFunctionModuleDict.PURCHASER.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [],

  children: [
    // 委托项目
    {
      path: 'projects',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '委托项目',
        layout: 'DefaultLayout'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.PURCHASER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],

      children: [
        // 委托列表
        {
          path: 'list',
          name: `PurchaserEntrustList`,
          component: '/procure-views/entrust/entrust-list/index',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '委托列表',
            cache: true,
            hidden: true,
            pageComponentName: 'PurchaserEntrustList'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 新建委托
        {
          path: ':projectId?/edit',
          name: `PurchaserEntrustForm`,
          component: '/procure-views/entrust/entrust-form/index',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '新建委托',
            hidden: true,
            needFormKey: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 委托详情
        {
          path: ':projectId/detail',
          name: `PurchaserEntrustDetail`,
          component: '/procure-views/entrust/entrust-detail/index',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '委托详情',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        }
      ]
    },

    // 采购项目
    {
      path: 'purchase',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '采购项目',
        layout: 'DefaultLayout'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.PURCHASER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],

      children: [
        // 采购列表
        {
          path: 'list',
          name: `EntrustPurchaseList`,
          component: '/procure-views/entrust/entrust-purchase-list/index',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '采购列表',
            cache: true,
            hidden: true,
            pageComponentName: 'EntrustPurchaseList'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 招标项目详情
        {
          path: 'bid/orders/:orderId/detail',
          name: `PurchaserBiddingProjectDetail`,
          component: '/project-views/bidding/index',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '招标项目详情',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 招标文件详情
        {
          path: 'bid/orders/:orderId/file-info/:biddingFileId',
          name: `PurchaserProjectInviteBidFileInfo`,
          component:
            '/procure-views/purchase/invite-bid/invite-bid-detail/bid-file-detail',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '招标文件详情',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 备案项目详情
        {
          path: 'supplement/orders/:orderId/detail',
          name: `PurchaserSupplementProjectDetail`,
          component: '/project-views/bidding/supplement',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '备案项目详情',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 询比项目详情
        {
          path: 'inquiry/orders/:orderId/detail',
          name: `PurchaserInquiryProjectDetail`,
          component: '/project-views/inquiry-project/index',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '询比项目详情',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 竞价项目详情
        {
          path: 'compete/orders/:orderId/detail',
          name: `PurchaserCompeteProjectDetail`,
          component: '/project-views/compete/index',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '竞价项目详情',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 谈判采购详情
        {
          path: 'negotiation-v2/orders/:orderId/detail',
          name: `PurchaserNegotiationV2ProjectDetail`,
          component: '/project-views/negotiation-v2/index',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '谈判采购详情',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 机场谈判详情
        {
          path: 'negotiation/orders/:orderId/detail',
          name: `PurchaserNegotiationProjectDetail`,
          component: '/project-views/negotiation/index',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '机场谈判详情',
            hidden: true
          },
          applicableCompanyTypes: [
            {
              companyType: companyTypeDict.ENTERPRISE.value,
              menuName: '谈判采购详情'
            },
            {
              companyType: companyTypeDict.PUBLIC_INSTITUTION.value,
              menuName: '谈判采购详情'
            }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        }
      ]
    }
  ]
}
